export const UNIT_LEVEL_TRACKING_LABEL = 'Unit level tracking'
export const STOCK_LEVEL_TRACKING_LABEL = 'Stock level tracking'

export const TRACKING_MODE_FILTER_OPTIONS = [
    {value: 'true', label: UNIT_LEVEL_TRACKING_LABEL},
    {value: 'false', label: STOCK_LEVEL_TRACKING_LABEL},
] as const

export const TRACKING_MODE_HELP_TEXT = [
    `${UNIT_LEVEL_TRACKING_LABEL}: each asset has a name and appears in the Equipment List.`,
    `${STOCK_LEVEL_TRACKING_LABEL}: quantity is tracked by type (e.g. mats), not individual units.`,
].join(' ')

export function trackingModeLabel(isUniquelyIdentified: boolean) {
    return isUniquelyIdentified ? UNIT_LEVEL_TRACKING_LABEL : STOCK_LEVEL_TRACKING_LABEL
}
